<section class="dbva-header">
    <div class="searchbar">
        <mis-input type="rounded" placeholder="Search">
            <span mis-input-icon><img src="/assets/images/search.svg" alt="search" /></span>
            <input type="text" [(ngModel)]="searchInput" (ngModelChange)="onSearchInputChange($event)" misInput
                placeholder="Start typing..." />
        </mis-input>

    </div>
    <div class="cityFilter">
        <mis-dropdown [data]="cities" [searchEnabled]="true" [label]="firstCity" height="38px" width="250px"
            dropdownListHeight="232px" dropdownListWidth="250px" dropdownListPosition="Left" noDataMessage="No Data"
            (onChange)="selectDesignationCity($event)">
        </mis-dropdown>
    </div>
    <button *ngIf="dbvaFlavour === 'CAPACITIVE'" (click)="openDefineCabsDialog()" class="dhcc-btn" [ngClass]="{'disabled': isLoading}">Define High Capacity Cabs</button>
</section>

<section class="dbva-page">
    <div class="dbva-table">
        <table>
            <thead>
                <tr>
                    <th>Designation</th>
                    <th>Vehicle</th>
                    <th *ngIf="dbvaFlavour === 'CAPACITIVE'">Enable High capacity</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let designation of filteredMap | keyvalue">
                    <td>{{designation.key}}</td>
                    <td>
                        <mis-multi-select-dropdown [enableSelectAll]="true" [hideApplyButton]="false"
                            [searchEnabled]="false" [data]="availableCabTypes" label="Select Vehicle" width="228px"
                            height="32px" [noDataMessage]="'no data'" [selectedItems]="designation.value.selectedVehicles"
                            [options]="{ sortLabels: false }" [showSelectedCount]="true"
                            (onChange)="selectedItems($event,designation.key)">
                        </mis-multi-select-dropdown>
                    </td>
                    <td *ngIf="dbvaFlavour === 'CAPACITIVE'">
                        <div class="checkbox-container displayFlexCenter align-item-center">
                            <mis-checkbox
                            [type]="'Default'"
                            [checked]="designation.value.hasHighCapacityAccess"
                            [name]="designation.key"
                            (valueChange)="handleCheckboxClick($event)"
                            >
                            </mis-checkbox>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <ng-template [ngIf]="showSuccessToast">
        <div class=" ava-snackbar">
            <span><img src="assets/successWhite.svg" alt="success"></span>
            {{toastMsg}}
        </div>
    </ng-template>
</section>

<app-dialog *ngIf="showSaveConfigWarning" titleText="Warning" type="confirm" [buttonText]="['Save', 'Discard']"
    (approveCallback)="makeButtonSubmitEnable()" (dismissCallback)="discardChanges(selectedCity)"
    (closeCallback)="showSaveConfigWarning=false" icon="true" src="assets/ic-ui-warning-24.svg">
    You have made changes for {{selectedCity}}.
    <div class="space"></div>
    Do you want to save or discard them before you proceed?
</app-dialog>

<section class="dbva-foot">
    <span (click)="setInitialConditions()">Reset</span>
    <span (click)="onSave()">Save</span>
</section>